export const getExtension = (fileName: any): any => {
    return /[^.]+$/.exec(fileName);
};
